import {} from './types.js'

export default {
  feedDesignators: state => {
    return state.feedDesignatorList
  },
  fullFeedDesignator: state => {
    return state.feedDesignator
  },
  designatorOptions: state => {
    return {
      text: state.uniqueDesignators,
      value: state.uniqueDesignators
    }
  },
  missionDesignatorsString: state => {
    const list = state.feedDesignatorList.filter(i => i.group == 'missions')
    return list[0] ? list[0].designators.join(',') : ''
  }
}
